import { Container, Grid } from "@mui/material";
import CandidateCard from "../../components/card/candidate-card";
import ReviewSection from "../../components/card/review-section";
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import axios from "axios";

const InterviewEvaluation = () => {
  const location = useLocation();
  const candidate = location.state?.user;
  const questions = location?.state?.questions;
  const urlid = location?.state?.user?.url_id;
  const [videoUrl, setVideoUrl] = useState(null);
  const [candidateQuestions, setCandidateQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // Track current question

  useEffect(() => {
    if (candidate?.url_id) {
      axios
        .get(`https://api.a2ajobs.com/api/candidate-questions?url_id=${candidate.url_id}`)
        .then((response) => {
          setCandidateQuestions(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching candidate questions:", error);
        });
    }
  }, [candidate?.url_id]);

  useEffect(() => {
    if (urlid) {
      axios
        .get(`https://api.a2ajobs.com/api/candidate-video/${urlid}`)
        .then((response) => {
          setVideoUrl(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching video:", error);
        });
    }
  }, [urlid]);

  // Get current video ID based on question index
  const getCurrentVideoId = () => {
    if (videoUrl?.media && videoUrl.media.length > currentQuestionIndex) {
      return videoUrl.media[currentQuestionIndex]?.id;
    }
    return null;
  };

  // Handler for question change
  const handleQuestionChange = (newIndex) => {
    setCurrentQuestionIndex(newIndex);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container justifyContent="center" gap={{ md: 8, xs: 2 }}>
        <Grid item xs={12} sm={4} md={3}>
          <CandidateCard
            candidate={candidate}
            video={videoUrl?.media}
            image={videoUrl?.image_url}
            questions={questions?.length > 0 ? questions : candidateQuestions[0]?.questions}
            videoIds={videoUrl?.media?.map(item => item.id)}
            currentVideoId={getCurrentVideoId()}
            currentQuestionIndex={currentQuestionIndex}
            onQuestionChange={handleQuestionChange}
          />
        </Grid>
        <Grid item xs={12} sm={8} md={6}>
          <ReviewSection
            questions={questions?.length > 0 ? questions : candidateQuestions[0]?.questions}
            video={videoUrl?.media}
            videoIds={videoUrl?.media?.map(item => item.id)}
            currentQuestionIndex={currentQuestionIndex}
            onQuestionChange={handleQuestionChange}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default InterviewEvaluation;